export default {
      id: "maintenance-usage",
      viewBox: "0 0 41 41",
      url: __webpack_public_path__ + "img/icons.svg#maintenance",
      toString: function () {
        return this.url;
      }
    }